// Tiny, safe markdown → HTML for comments (fenced code blocks, inline code, bold, italic, links, breaks).
const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function renderMarkdown(text) {
  if (!text) return "";
  const parts = String(text).split(/```/);
  let html = "";
  parts.forEach((chunk, i) => {
    if (i % 2 === 1) {
      // fenced code block (drop optional language on first line)
      const body = chunk.replace(/^[a-zA-Z0-9]*\n/, "");
      html += `<pre class="bg-muted/60 rounded-sm p-2 my-1 overflow-x-auto text-xs font-mono whitespace-pre">${esc(body)}</pre>`;
    } else {
      let s = esc(chunk);
      s = s.replace(/`([^`]+)`/g, '<code class="bg-muted/60 rounded px-1 font-mono text-[0.85em]">$1</code>');
      s = s.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
      s = s.replace(/(^|[^*])\*([^*]+)\*/g, "$1<em>$2</em>");
      s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer" class="text-primary underline">$1</a>');
      s = s.replace(/\n/g, "<br/>");
      html += s;
    }
  });
  return html;
}
